// 定义德语语言包对象
// 德语
exports.default = {
    el: {
        colorpicker: {
            confirm: 'OK',
            clear: 'Leeren'
        }
    }
};